export default {
  'navbar.lang': 'English',
  'menu.home': 'Home',
  'menu.dashboard': 'Dashboard',
  'menu.profile': 'Profile',
  'menu.settings': 'Settings',

  // User: login/register
//   'user.login.title': 'Sign in to your account',
  'user.login.subtitle': 'Enter your credentials to continue',
  'user.login.username': 'Username or email',
  'user.login.password': 'Password',
  'user.login.forgot': 'Forgot password?',
  'user.login.button': 'Login',

  'user.register.title': 'Create a new account',
  'user.register.button': 'Register',
  'user.register.success': 'Account created. Check your email to verify.',


  'user.login.title': 'Scan Successful!',
  'user.login.welcome.subheading': 'Welcome to a world where freedom meets exceptional living! Scan. Earn. Live Free. Live Exceptional',
  'user.login.description': 'You have successfully scanned our QR code. Sign in or Sign up below to claim your reward, points and win amazing prizes',
  'user.login.signin.title': 'Sign In',
  'user.login.signin.sub': 'To sign in please enter your mobile number and we will send a verification code',
  'user.login.phoneNumberLabel': 'Phone Number',
  'user.login.enterPhonePlaceholder': 'Enter phone number',
  'user.login.invalidPhone': 'Invalid phone number',
  'user.login.phoneRequired': 'Phone number is required',
  'user.login.signingIn': 'Signing in...',
  'user.login.continue': 'Continue',
  'user.login.noAccount': "Don’t have an account?",
  'user.login.signup': 'Sign up',
  'user.login.footerCopyright': 'Copyright © {year}. Powered by Exceptional Brands',

  // Signup page
  'user.register.welcome': 'Welcome !',
  'user.register': 'Sign Up to Claim your Rewards',
  'user.register.description': 'Complete your details below to earn points and unlock rewards, and win amazing prizes',

  'user.register.phone.label': 'Phone Number',
  'user.register.phone.placeholder': 'Enter phone number',
  'user.register.phone.required': 'Phone number is required',
  'user.register.phone.invalid': 'Invalid phone number',

  'user.register.name.label': 'Your Name',
  'user.register.name.placeholder': 'e.g. Mark',
  'user.register.name.required': 'Name is required',

  'user.register.ageGroup.label': 'Age group (Optional)',
  'user.register.gender.label': 'Gender (Optional)',
  'user.register.gender.male': 'Male',
  'user.register.gender.female': 'Female',

  'user.register.terms.agreement': 'By proceeding, you agree to our {termsLink} and {privacyLink}.',
  'user.register.terms.termsOfService': 'Terms of Service',
  'user.register.terms.privacyPolicy': 'Privacy Policy',

  'user.register.creating': 'Creating Profile…',
  'user.register.create': 'Create Profile',

  'user.register.alreadyAccount': 'Already have an account?',
  'user.register.signin': 'Sign in',

  'user.register.footer.copyright': 'Copyright © {year}. Powered by Exceptional Brands',
  


  'user.welcome.welcome': 'Welcome {name}!',
  'user.welcome.points_earned': "Congratulations, you've earned",
  'user.welcome.thank_you': 'Thank you for signing up!',
  'user.welcome.earn_more_points': 'To earn more points, rate more products you have purchased from us.',
  'user.welcome.continue': 'Continue',
  'user.welcome.logging_in': 'Logging in...',

  'user.brand-product-review.title': 'Select Brand and Product to Continue',
  'user.brand-product-review.continue': 'Continue',
  'user.brand-product-review.select-product': 'Select a product to continue',
  'user.brand-product-review.review-products': 'Review our products to earn points',
  'user.brand-product-review.rate-product': 'Please rate at least one product above to continue',
  'user.brand-product-review.footer': 'Copyright © {year}. Powered by Exceptional Brands',
  

  'scansuccess.review.heading': 'How would you rate the product',
  'scansuccess.review.continue': 'Retailer Code ( Optional )',
  'scansuccess.review.select-product': 'Add a retailer code to earn more points',
  'scansuccess.review.review-products': 'Submit Review',
 

  'scansuccess.congratulations.heading': 'Congratulations!',
  'scansuccess.congratulations.continue': 'You have earned',
  'scansuccess.congratulations.select-product': 'Thank You For Your Review',
  'scansuccess.congratulations.review-products': 'To earn more points rate more products that you have been able to buy from us',
  'scansuccess.congratulations.create': 'Go to Dashboard',
 'user.brand-product-review.titles': 'Go to Dashboard',
  // Scan success pages
  'scansuccess.title': 'Scan Result',
  'scansuccess.scan.message': 'Thank you — your scan was successful.',
  'scansuccess.scan.instructions': 'You can claim points, leave a review or sign up for offers.',
  'scansuccess.signup.title': 'Sign up to claim rewards',
  'scansuccess.signup.button': 'Sign up',
  'scansuccess.welcomepoints.title': 'Welcome Points',
  'scansuccess.welcomepoints.pointsLabel': 'Points awarded',
  'scansuccess.brandproductreview.title': 'Brand & Product Review',
  'scansuccess.brandproductreview.leaveReview': 'Leave a review',
  'scansuccess.productreview.title': 'Product Review',
  'scansuccess.productreview.submit': 'Submit review',
  'scansuccess.congratulations.title': 'Congratulations!',
  'scansuccess.congratulations.message': 'You\'ve earned points — check your dashboard to redeem.',

  // Dashboard
  'dashboard.title': 'Welcome!',
  'dashboard.balance': 'Your Balance',
  'dashboard.balance-sub': 'points',
  'dashboard.redeem': 'Redeem',
  'dashboard.stat': 'Total Scans',
  'dashboard.label': 'Rewards Won',
  'dashboard.redeem.title': 'Redeem Your Points',
  'dashboard.redeem.success': 'Redeem Rewards',
  'dashboard.primary-sub': 'Use your points to unlock rewards',
  'dashboard.secondary-btn': 'Scan Again',
  'dashboard.secondary': 'Refer Friend',
  'dashboard.loyalty': 'Loyalty Tiers',
  'dashboard.5000pts': '5000 pts',
  'dashboard.100pts': '100 pts to Platinum',
  'dashboard.almost-there': 'Almost there!',
  'dashboard.recent': 'Recent Activity',
 

  'dashboard.redeem.points': ' Redeem Your Points',
  'dashboard.redeem.subtitle': 'Use your points to unlock rewards',
  'dashboard.redeem.sub': 'points',
  'dashboard.redeem.progress': 'Progress to Platinum',
  'dashboard.redeem.stat': ' Available Rewards',
  'dashboard.redeem.label': 'Redeem',
  'dashboard.redeem.need': 'Need',
  'dashboard.redeem.prize': 'Prize Draw',
  'dashboard.redeem.scan': 'The more you scan the more your chances of winning something amazing',
  'dashboard.redeem.recent': 'Recent Activity',
  // Settings / Profile
  'settings.title': 'Settings',
  'settings.balance': 'Gold Member',
  'settings.balance-sub': ' Points',
  'settings.redeem': 'Account',
  'settings.stat': '  Edit Profile',
  'settings.label': ' Update personal information',
  'settings.redeem.title': ' Preferences',
  'settings.redeem.success': 'Notifications',
  'settings.primary-sub': 'Push, email preferences',
  'settings.secondary-btn': 'Language',
  'settings.secondary': ' English (US)',
  'settings.loyalty': 'Support & Legal',
  'settings.5000pts': ' Help & Support',
  'settings.100pts': ' FAQ, contact us',
  'settings.almost-there': 'Terms & Conditions',
  'settings.recent': 'Legal information',
  'settings.points': 'Privacy Policy',
  'settings.data': 'Data protection info',
  'settings.sign': 'Sign Out',





  'profile.title': 'My Profile', 
  'profile.balance': '% Complete',
  'profile.balance-sub': '% remaining',
  'profile.redeem': '✓ Profile Complete',
  'profile.stat': 'Profile Information',
  'profile.label': 'pts',
  'profile.redeem.title': 'Connect Social Media',
  'profile.redeem.success': ' Earn points for each connection!',
  'profile.primary-sub': ' Facebook',
  'profile.secondary-btn': '+20 pts',
  'profile.secondary': 'Instagram',
  'profile.loyalty': '+20 pts',
  'profile.5000pts': 'X (Twitter)',
  'profile.100pts': '+20 pts',
  'profile.almost-there': 'Connect your social media for a 20 point bonus!',
  'profile.recent': 'Fill in the following fields to complete your profile and earn{" "}',
  'profile.points': 'bonus points:',





  // Global & fallback
  'global.back': 'Back',
  'global.next': 'Next',
  'global.search.placeholder': 'Search...',
  'validation.required': 'This field is required',
  'error.404.title': 'Page not found',
  'error.404.subTitle': "Sorry, we couldn't find the page you're looking for.",
};
